import { Constant, Name, Option, Zone, Structure } from 'types';
import { User } from 'types/api/users.type';

export const mapStringIntoOptions = (data: string[]): Option[] =>
  data?.map((item: string) => ({
    value: item,
    label: item,
  }));

export const mapConstantIntoOptions = (data: Constant[], asRanking?: boolean) =>
  data.map((item: Constant) => ({
    value: item.key,
    label: asRanking ? `${item.value} stars` : item.value,
  }));

export const mapNameIntoOptions = (data: Name[]): Option[] =>
  data.map(
    (item: Name): Option => ({
      value: item.id,
      label: item.name,
    })
  );

export const mapZonesIntoOptions = (data: Zone[]): Option[] =>
  data.map(
    (item: Zone): Option => ({
      value: item.code,
      label: item.code,
    })
  );

export const mapUsersIntoOptions = (data: User[]): Option[] =>
  data.map(
    (item: User): Option => ({
      value: item.id,
      label: `${item.name} ${item.surname}`.trim() || item.email,
    })
  );

export const mapStructureIntoOptions = (data: Structure[], type: string): Option[] => {
  const structures = data.map(
    (item: Structure): Option => ({
      value: item.key,
      label: item.value,
    })
  );

  if (type === 'SPEC') {
    return structures.slice(3);
  }

  if (type === 'STAND') {
    return structures.slice(0, 4);
  }

  return structures;
};
